import {
  Chip,
  InputBase,
  Select,
  MenuItem,
  IconButton,
  Box,
  styled,
} from '@mui/material';

export const StyledChipContainer = styled(Box)<{ readOnly?: boolean }>(
  ({ readOnly }) => ({
    display: 'inline-flex',
    alignItems: 'center',
    cursor: readOnly ? 'default' : 'pointer',
  }),
);

export const StyledEditSection = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
});

export const StyledViewSection = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
});

export const CustomChip = styled(Chip)(({ theme }) => ({
  fontSize: 14,
  fontWeight: 500,
  letterSpacing: '-0.03em',
  lineHeight: '16px',
  borderRadius: 8,
  padding: '4px 6px',
  color: theme.palette.text.primary,
  background: 'transparent',
  border: `1px solid ${theme.palette.border?.main}`,
  height: 24,
  '& .MuiChip-label': {
    paddingLeft: 0,
    paddingRight: 0,
  },
}));

export const CustomInput = styled(InputBase)(({ theme }) => ({
  fontSize: 14,
  fontWeight: 500,
  letterSpacing: '-0.03em',
  lineHeight: '16px',
  minWidth: 60,
  marginLeft: 2,
  '& .MuiInputLabel-root': {
    fontSize: 12,
  },
  '& .MuiInputBase-input': {
    padding: 0,
    borderBottom: `1px solid ${theme.palette.border?.main}`,
  },
}));

export const CustomSelect = styled(Select)(({ theme }) =>({
  minWidth: 55,
  textAlign: 'center',
  '& .MuiSelect-select': {
    padding: 0,
    fontSize: 14,
    fontWeight: 500,
    letterSpacing: '-0.03em',
    lineHeight: '16px',
    borderBottom: `1px solid ${theme.palette.border?.main}`,
  },
}));

export const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
  fontFamily: theme.typography.fontFamily,
  fontWeight: 500,
  fontSize: 14,
  borderRadius: 8,
  textWrap: 'inherit',
  width: '100%',
  '&:hover': {
    borderRadius: 0,
    backgroundColor: 'rgba(24, 205, 205, 0.08)',
  },
  '&.Mui-selected': {
    fontWeight: 500,
    borderRadius: 0,
  },
  '&.Mui-selected:hover': {
    backgroundColor: 'rgba(24, 205, 205, 0.08) !important',
  },
}));

export const IconBtn = styled(IconButton)(({ theme }) => ({
  padding: 0,
  '&.Mui-disabled': {
    color: theme.palette.text.disabled,
    cursor: 'pointer',
  },
}));

export const StyledKeywordLabel = styled('span')<{ readOnly?: boolean }>(
  ({ readOnly, theme }) => ({
    color: readOnly
      ? theme.palette.text.inputPlaceholder
      : theme.palette.text.primary,
    fontSize: 14,
    fontWeight: 500,
  }),
);

export const StyledKeywordValue = styled('span')(({ theme }) => ({
  color: theme.palette.text.tertiary,
  fontSize: 14,
  fontWeight: 500,
}));

export const StyledErrorText = styled(Box)(({ theme }) => ({
  fontSize: 12,
  color: theme.palette.error.main,
}));